module.exports = __webpack_public_path__ + "static/media/yt.f8597fad.svg";